import React, { PureComponent, Fragment } from 'react';

// Components
import Gallery from 'components/gallery/gallery.component';
import Header from 'components/header/header.component';

// Images
import GalleryImage0 from 'images/about_0.jpg';
import GalleryImage1 from 'images/about_1.jpg';
import GalleryImage2 from 'images/about_2.jpg';
import GalleryImage3 from 'images/about_3.jpg';
import GalleryImage4 from 'images/about_4.jpg';
import GalleryImage5 from 'images/about_5.jpg';
import GalleryImage6 from 'images/about_6.jpg';
import GalleryImage7 from 'images/about_7.jpg';

// Texts
import text from 'i18l';

const GALLERY_IMAGES = [
  {
    src: GalleryImage0,
  }, {
    src: GalleryImage1,
  }, {
    src: GalleryImage2,
  }, {
    src: GalleryImage3,
  }, {
    src: GalleryImage4,
  }, {
    src: GalleryImage5,
  }, {
    src: GalleryImage6,
  }, {
    src: GalleryImage7,
  },
];

class AboutComponent extends PureComponent {
  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {

    return (
      <Fragment>
        <Header/>
        <Gallery
          title={text.ABOUT.GALLERY_TITLE}
          description={text.ABOUT.GALLERY_DESCRIPTION}
          images={GALLERY_IMAGES}
        />
      </Fragment>
    );
  }
}

export default AboutComponent;


// WEBPACK FOOTER //
// ./src/routes/about/about.component.js